export default __webpack_public_path__ + "static/media/1963.af6387b3.png";